import React, { useState } from "react"
import SearchIcon from "@mui/icons-material/Search"
import useStyles from "./useStyles"
import { CircularProgress, Modal, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useDispatch, useSelector } from "react-redux"
import {
  addNewSearchValue,
  addNewSearchValueSubscription,
  getAllSubscriptionsCommunication,
  getAllSubsDelegationVE,
} from "../../redux/actions/eventanilla"
import { getFirmsCustomer } from "../../redux/actions/clients"
import { useNavigate } from "react-router-dom"
//import { getAllSubscriptionDelegationsVE } from "../../app/services/eventanilla/getAllSubscriptionDelegationsVE"

export default function FilterButton({ searchType, setSearched = null }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openModal, setopenModal] = useState(false)
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [error, seterror] = useState(false)
  const [disabled, setdisabled] = useState(false)
  const [errorText, seterrorText] = useState("")
  const [CUIT, setCUIT] = useState("")
  const eventanilla = useSelector((state) => state.eventanilla)
  const navigate = useNavigate()

  const handleChangeOpenModal = () => {
    if (!openModal) {
      setCUIT("")
      seterror(false)
      seterrorText("")
    }
    setopenModal(!openModal)
  }

  const valoresAceptados = /^[0-9]+$/

  const validateCUIT = (number) => {
    return !!(number.match(valoresAceptados) && number.length === 11)
  }

  const handleChange = (e) => {
    setCUIT(e.target.value)
    if (e.target.value !== "") {
      if (
        !e.target.value.match(valoresAceptados) ||
        e.target.value.length > 11
      ) {
        seterrorText("El CUIT debe contener 11 números, sin guiones")
        seterror(true)
      } else {
        seterror(false)
      }
    } else {
      seterror(false)
    }
  }

  const handleSubmitFunction = (event) => {
    if (event.type === "keydown" && event.key === "Enter") {
      handleClickFunction()
    }
  }

  const handleClickFunction = async () => {
    setShowCircularProgress(true)
    setdisabled(true)
    if (!validateCUIT(CUIT)) {
      seterrorText("El CUIT debe contener 11 números, sin guiones")
      seterror(true)
    } else {
      // await dispatch(getAllSubscriptionsCommunication(CUIT, eventanilla.searchClientName, eventanilla.searchStatus))
      // dispatch(addNewSearchValue(CUIT))
      switch (searchType) {
        case "eventanilla":
          await dispatch(
            getAllSubscriptionsCommunication(
              CUIT,
              eventanilla.searchClientName,
              eventanilla.searchStatus,
            ),
          )
          dispatch(addNewSearchValue(CUIT))

          break
        case "firmsCustomer": {
          await dispatch(getFirmsCustomer(CUIT))
          navigate(`?cuit=${CUIT}`, { replace: true })
          break
        }
        case "subscription": {
          await dispatch(getAllSubsDelegationVE(CUIT))
          dispatch(addNewSearchValueSubscription(CUIT))
          break
        }

        default:
      }
      handleChangeOpenModal()
      if (setSearched) setSearched(true)
    }
    setShowCircularProgress(false)
    setdisabled(false)
  }

  return (
    <>
      <button className={classes.buttonsearch} onClick={handleChangeOpenModal}>
        <SearchIcon className={classes.searchIconButton} />
        <div className={classes.typographyButton}>Buscar por CUIT</div>
      </button>
      <Modal open={openModal}>
        <div className={classes.boxModal}>
          <div
            style={{
              color: "#263057",
              width: "90%",
              height: "90%",
              fontFamily: "Raleway",
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <CloseIcon
                sx={{
                  color: "#263057",
                  cursor: "pointer",
                }}
                onClick={() => setopenModal(false)}
              />
            </div>
            <div>
              <h1
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                Buscar un cliente por CUIT
              </h1>
              <p
                style={{
                  marginTop: "20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "Roboto",
                }}
              >
                Ingrese el CUIT del cliente que desea buscar
              </p>
              <TextField
                sx={{ width: "70%" }}
                autoFocus
                margin="dense"
                id="name"
                type="text"
                value={CUIT}
                onChange={handleChange}
                onKeyDown={handleSubmitFunction}
                placeholder={"Ej: 30582622945"}
                variant="standard"
                error={error}
                helperText={error ? errorText : ""}
              />
            </div>
            <div className={classes.buttons}>
              <ButtonClose handleClose={handleChangeOpenModal} />
              <ButtonConfirm
                showCircularProgress={showCircularProgress}
                disabled={disabled}
                handleClickFunction={handleClickFunction}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
function ButtonConfirm({
  showCircularProgress,
  disabled,
  handleClickFunction,
}) {
  const classes = useStyles()

  return (
    <button
      className={classes.confirmButton}
      style={{ backgroundColor: disabled ? "#BFBFBF" : "#00A88F" }}
      onClick={handleClickFunction}
      disabled={disabled}
    >
      {showCircularProgress ? (
        <CircularProgress size="1.5rem" color="inherit" />
      ) : (
        <h2 className={classes.confirmButtonTypography} variant="contained">
          Buscar
        </h2>
      )}
    </button>
  )
}

function ButtonClose({ handleClose }) {
  const classes = useStyles()

  return (
    <div onClick={handleClose} className={classes.closeButton}>
      Cancelar
    </div>
  )
}
